import SearchHeaderBlock from './searchHeaderBlock'

export default SearchHeaderBlock
